<script setup>
import { computed, useSlots } from 'vue'

defineProps({
  label: {
    type: String,
    default: null
  },
  help: {
    type: String,
    default: null
  },
  danger: {
    type: String,
    default: null
  },
  upperText:Boolean
})

const slots = useSlots()

const wrapperClass = computed(() => {
  const base = []
  const slotsLength = slots.default().length

  if (slotsLength > 1) {
    base.push('grid grid-cols-1 gap-3')
  }

  if (slotsLength === 2) {
    base.push('md:grid-cols-2')
  }
  if (slotsLength === 3) {
    base.push('md:grid-cols-3')
  }

  return base
})
</script>

<template>
  <div class="mb-2 last:mb-0">
    <div :class="upperText? '':'flex'" v-if="label">
      <label
          class="flex items-center font-semibold text-xs"
          :class="upperText? 'w-full':'min-w-[20%] mr-4'"
      >{{ label }}</label>
      <div :class="[wrapperClass,upperText? 'w-full':'grow']">
        <slot />
      </div>
    </div>
    <div v-else :class="wrapperClass">
        <slot />
    </div>
    <div
      v-if="help"
      class="text-xs text-gray-500 dark:text-gray-400 mt-1"
    >
      {{ help }}
    </div>
    <div
      v-if="danger"
      class="text-xs text-red-600 dark:text-red-400 mt-1"
    >
      {{ danger }}
    </div>
  </div>
</template>
